const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/medic_hosp/EmptyRouterView.vue");
const medicHosp = () => /* webpackChunkName: "Home" */ import("./../views/medic_hosp/Home.vue");
const Contrarref = () => /* webpackChunkName: "Contrarrefs" */ import("./../views/medic_hosp/contrarref/Contrarrefs.vue");
const MedicAtention = () => /* webpackChunkName: "medicAtentions" */ import("./../views/medic_hosp/medic_atention/medicAtentions.vue");
const MedicAtentionGroup = () => /* webpackChunkName: "medicAtentionsGroup" */ import("./../views/medic_hosp/medic_atention/medicAtentionsGroup.vue");
const SpecialistProfessional = () => /* webpackChunkName: "SpecialistProfessional" */ import("./../views/medic_hosp/telemedical/SpecialistProfessional.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/administrative/archive_request/ArchiveRequestHome.vue");
const RegisterAtentions = () => /* webpackChunkName: "RegisterAtentions" */ import("./../views/medic_hosp/registerAtention/registerAtentions.vue");
const SicNoPertinent = () => /* webpackChunkName: "ApsRequestHome" */ import("./../views/medic_hosp/interconsult/SicNoPertinent.vue");

const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/medicHosp",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "medicHospHome",
        component: medicHosp,
      },
      {
        path: "atencionMedica",
        name: "medicAtention",
        component: MedicAtention,
      },
      {
        path: "atencionMedicaGrupo",
        name: "MedicAtentionGroup",
        component: MedicAtentionGroup,
      },
      {
        path: "contrareferencia",
        name: "contrarrefsHops",
        component: Contrarref,
      },
      {
        path: "interconsulta-profesional-especialista",
        name: "specialistProfesional",
        component: SpecialistProfessional,
      },
      {
        path: "solicitud-archivo",
        name: "medicHospArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "registro-antecedentes",
        name: "medicHospRegisterAtentions",
        component: RegisterAtentions,
      },
      {
        path: "interconsulta-no-pertinentes",
        name: "sicNoPertinent",
        component: SicNoPertinent,
      },
      {
        path: "documentacion",
        name: "medicHospDocumentation",
        component: Document,
      },
    ],
  },
];
